import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=4c156aac&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=4c156aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c156aac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c156aac')) {
      api.createRecord('4c156aac', component.options)
    } else {
      api.reload('4c156aac', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=4c156aac&scoped=true&", function () {
      api.rerender('4c156aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Carousel.vue"
export default component.exports